import { FunctionComponent, h } from 'preact';
import Translate from '../translate/translate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { DeliveryWindowWithId } from '../../stores/schedule/schedule-store';
import { DeliveryWindow } from '@bringg/types';
import DateService from '../../services/date-service';

interface Props {
	deliveryWindow: DeliveryWindowWithId | DeliveryWindow;
}

const ScheduleSuccess: FunctionComponent<Props> = ({ deliveryWindow = {} }) => {
	const { start_time, end_time } = deliveryWindow;

	const formattedDeliveryWindow =
		deliveryWindow && `${DateService.formatLocalizedDate(start_time)} - ${DateService.formatTime(end_time)}`;

	return (
		<div className="schedule-success" data-testid="schedule-success">
			<div className="schedule-success-message">
				<Translate text="SCHEDULE.YOU_ARE_ALL_SET" />
			</div>
			<FontAwesomeIcon className="schedule-success-icon" icon={faCheckCircle} />
			{start_time && end_time && (
				<div className="schedule-delivery-window-container">
					<div className="schedule-success-message-scheduled-for">
						<Translate text="SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR" />
					</div>
					<div className="schedule-success-message-delivery-window">{formattedDeliveryWindow}</div>
				</div>
			)}
		</div>
	);
};

export default ScheduleSuccess;
